<template>
  <div>
    <v-img
      v-if="validUrl"
      :src="validUrl"
      :width="width"
      :height="height"
      :class="className"
      @error="onImageError"
    >
    </v-img>
    <no-image v-else :width="width" :height="height" />
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '117px',
    },
    height: {
      type: String,
      default: '66px',
    },
    className: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      imageError: false,
    };
  },
  computed: {
    validUrl() {
      return this.imageError || !this.url ? null : this.url;
    },
  },
  methods: {
    onImageError() {
      this.imageError = true;
    },
  },
};
</script>
